import { RootState } from "@/app/stores";
import { createSelector } from "@reduxjs/toolkit";

const baseSeletor = createSelector(
    (state: RootState) => state,
    (state) => state.bonusTransaction
)

export const selectBonusTransactionCheck = createSelector(
    baseSeletor,
    (state) => state.checks
)
export const selectBonusTransactionStore = createSelector(
    baseSeletor,
    (state) => state.stores
)
export const selectBonusTransaction = createSelector(
    baseSeletor,
    (state) => state.transaction
)
export const selectBonusTransactionError = createSelector(
    baseSeletor,
    (state) => state.error
)
export const selectBonusTransactionLoading = createSelector(
    baseSeletor,
    (state) => state.isLoading
)